export const getMaxLengthErrorMessage = (limit: number) => `This value cannot exceed ${limit} characters.`;
